import { SiteEffects } from './site/site.effects';
import { PagesEffects } from './pages/pages.effects';
import { ContentEffects } from './content/content.effects';
import { PageVersionSyncEffects } from './content/page-version-sync.effects';
import { SettingsEffects } from './settings/settings.effects';
import { PageSettingsEffects } from './page-settings/page-settings.effects';
import { DomainsEffects } from './domains/domains.effects';
import { ProductCatalogEffects } from './product-catalog/product-catalog.effects';

export const WebsiteEffects = [
    SiteEffects,
    PagesEffects,
    ContentEffects,
    PageVersionSyncEffects,
    SettingsEffects,
    PageSettingsEffects,
    DomainsEffects,
    ProductCatalogEffects,
];
